import React from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToProjects = () => {
    const projectsSection = document.getElementById("projects-section");
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const goToContact = () => {
    navigate("/contact-us");
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-blue-500 via-blue-400 to-blue-700">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -left-20 sm:-left-40 top-10 sm:top-20 w-48 sm:w-96 h-48 sm:h-96 rounded-full bg-blue-400 opacity-20 blur-3xl"></div>
        <div className="absolute -right-20 sm:-right-40 bottom-10 sm:bottom-20 w-48 sm:w-96 h-48 sm:h-96 rounded-full bg-blue-800 opacity-20 blur-3xl"></div>
        <div className="absolute left-1/4 top-1/3 w-32 sm:w-64 h-32 sm:h-64 rounded-full bg-cyan-400 opacity-10 blur-2xl"></div>
      </div>

      {/* Dot pattern effect - circular radiating pattern */}
      <div className="absolute inset-0 opacity-40">
        {Array.from({ length: 15 }).map((_, ring) => {
          const dotsInRing = 8 + ring * 4;
          const radius = 50 + ring * 30;
          return Array.from({ length: dotsInRing }).map((_, dotIndex) => {
            const angle = (dotIndex / dotsInRing) * 2 * Math.PI;
            const x = 50 + Math.cos(angle) * (radius / 10);
            const y = 50 + Math.sin(angle) * (radius / 10);
            return (
              <div
                key={`${ring}-${dotIndex}`}
                className="absolute bg-white rounded-full"
                style={{
                  width: "10px",
                  height: "10px",
                  left: `${x}%`,
                  top: `${y}%`,
                  opacity: Math.max(0.15, 0.6 - ring * 0.03),
                }}
              />
            );
          });
        })}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative flex items-center min-h-screen">
        <div className="text-center w-full">
          <div className="inline-block px-4 sm:px-6 md:px-8 py-2 sm:py-3 bg-white bg-opacity-20 backdrop-blur-sm text-white rounded-full text-xs sm:text-sm md:text-base mb-6 sm:mb-8 md:mb-10 border border-white border-opacity-30">
            Built on innovation. Driven by trust.
          </div>

          <h1 className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 sm:mb-8 md:mb-10 leading-tight px-4">
            Seamless Simplicity For
            <br />
            Every Digital Need
          </h1>

          <p className="text-white text-sm sm:text-lg md:text-xl lg:text-2xl mb-8 sm:mb-12 md:mb-16 max-w-5xl mx-auto leading-relaxed opacity-90 px-4">
            Transform your business with cutting-edge technology solutions,
            <br className="hidden sm:block" />
            expert design, and reliable support that drives sustainable growth
            and innovation.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4">
            <button
              onClick={goToContact}
              className="bg-black text-white px-8 sm:px-10 md:px-12 py-3 sm:py-4 md:py-5 rounded-full text-base sm:text-lg md:text-xl font-medium hover:bg-gray-900 transition shadow-lg"
            >
              Get Started Today
            </button>
            <button
              onClick={scrollToProjects}
              className="border-2 border-white text-white px-8 sm:px-10 md:px-12 py-3 sm:py-4 md:py-5 rounded-full text-base sm:text-lg md:text-xl font-medium hover:bg-white hover:bg-opacity-10 transition backdrop-blur-sm"
            >
              View Our Work
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
